import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_contact.scss';
import Dropdown from '../Reusables/Dropdown';
import getResponseEntity from '../actions/Entity.js';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import { useNavigate } from "react-router-dom";
import getResponse from '../actions/Project';
import Snackbars from '../Reusables/Snackbar';
import { trim } from '../Reusables/Function';

import closeIcon from '../../images/popups/upload/closeicon.png';

function AddContact(props) {
    const {show, handleClose, getEntityDetails, selectedEntityList, 
        entityDetails, setEntityDetails, propertyLabel, setPropertyLabel,
        error, setError} = props;
    const navigate = useNavigate();

    const [enable, setEnable] = useState(null);
    const [open, setOpen] = useState(null)

    useEffect(() => {
        if(selectedEntityList.length == 0) {
            setEnable(false);
        } else {
            setEnable(true)
        }
    }, [selectedEntityList])

    const handleSelectProperty = (name, id) => {
        setEntityDetails({
            ...entityDetails,
            idEntities: id,
            name: name
        })
    }

    const handleRelationship = (type) => {
        setEntityDetails({
            ...entityDetails,
            relationship: type
        })
    }

    const handleSave = () => {
        if((entityDetails.name === '' || entityDetails.name === null)) {
            setError('Property is mandatory');
            setOpen(true);
        } else {
            setError('');
            setOpen(false);
            handleClose();
            getEntityDetails(entityDetails);
        }
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='add-contact-popup'
                centered>
                <Modal.Body className='add-contact-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='add-contact-popup-header'>Add Property</div>
                    <div className='add-contact-popup-body'>
                        <div className='contact-container'>
                            <label className='required'>Property Name</label>
                            <Dropdown label={propertyLabel} selectedItem={(name, id) => handleSelectProperty(name, id)}
                                handleLabel={(value) => setPropertyLabel(value)} list={selectedEntityList} enable={enable} searchbar={true}/>
                        </div>
                        <div className='relationship-container'>
                            <label>Relationship</label>
                            <div><input value={entityDetails.relationship} className={enable ? 'input-element' : 'input-grey-shadow'} type="text" 
                            onChange={(e) => handleRelationship(e.target.value)} maxLength={100}/></div>
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button onClick={handleSave}>Save</button>
                    </div>            
                </Modal.Body>
            </Modal>
            <Snackbars error={error} open={open} setOpen={setOpen}/>
        </>
    );
}

export default AddContact;